import { AddButton } from '@/common/buttons/AddButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const EntityPropList = ({ parentEntity, parentEntityObj, showAddButton = true }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!parentEntity) return;
    rowsReq.expr = ExprUtils.whereParams('entity', parentEntity, 'entityId', parentEntityObj.id);
  }, [parentEntity, parentEntityObj])

  const augNavEntityObj = (navEntityObj) => {
    ObjUtils.clearObj(navEntityObj);
    navEntityObj.entity = parentEntity;
    navEntityObj.entityId = parentEntityObj.id;
    if ('startDate' in parentEntityObj) {
      navEntityObj.startDate = parentEntityObj.startDate;
    }
    if ('endDate' in parentEntityObj) {
      navEntityObj.endDate = parentEntityObj.endDate;
    }
  }
  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    if (showAddButton) {
      tabButtons.push(<AddButton entity="ENTITY_PROP" augNavEntityObj={augNavEntityObj} />);
    }
  }

  return (
    <EntityList
      entity="ENTITY_PROP"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
    />
  );
}